import { useEffect, useState } from 'react';
import { currentAccount, finishVkLogin, logoutAccount, startVkLogin } from './vk-auth';
import type { AccountIdentity } from './vk-auth';

let initialAccount: Promise<AccountIdentity | null> | null = null;
function loadAccount() {
  if (!initialAccount) {
    const request=(async () => (await finishVkLogin()) ?? currentAccount())();
    initialAccount=request;
    void request.catch(() => { if (initialAccount===request) initialAccount=null; });
  }
  return initialAccount;
}
export function useAccount() {
  const [identity,setIdentity]=useState<AccountIdentity | null>(null);
  const [busy,setBusy]=useState(true);
  const [error,setError]=useState('');
  useEffect(()=>{ let live=true; void (async()=>{
    try { const account=await loadAccount(); if(live)setIdentity(account); }
    catch(e){if(live)setError(e instanceof Error ? e.message : 'Не удалось проверить аккаунт.');}
    finally {if(live)setBusy(false);}
  })();
  const retry=()=>{if(!live)return;void loadAccount().then(value=>{if(live){setIdentity(value);setError('');}}).catch(()=>{});};
  const expired=()=>{initialAccount=null;setIdentity(null);setError('Сеанс истёк. Войдите через VK ID снова.');};
  window.addEventListener('online',retry);window.addEventListener('yumnote:account-expired',expired);
  return ()=>{live=false;window.removeEventListener('online',retry);window.removeEventListener('yumnote:account-expired',expired);}; },[]);
  async function login(){setError('');setBusy(true);try{await startVkLogin();}catch(e){setError(e instanceof Error ? e.message : 'Не удалось начать вход.');setBusy(false);}}
  async function logout(){setError('');setBusy(true);try{await logoutAccount();initialAccount=null;setIdentity(null);}catch(e){setError(e instanceof Error ? e.message : 'Не удалось выйти.');}finally{setBusy(false);}}
  async function retry(){setBusy(true);setError('');initialAccount=null;try{setIdentity(await loadAccount());}catch(e){setError(e instanceof Error ? e.message : 'Не удалось проверить аккаунт.');}finally{setBusy(false);}}
  return {userId:identity?.userId ?? null, identity,busy,error,login,logout,retry};
}
